import React, { Component, Fragment } from 'react';
import PropTypes from 'prop-types';
import { toAssetsExtUrl } from 'utils/assetsExtUrl';
import classname from 'classnames';

import { rgbToAlfa } from '../../../selectors/UtilSelectors';
import BZPersonIcon from 'web-common/bizzabo-components/components/BZPersonIcon';
import BZAutosuggest from 'web-common/bizzabo-components/components/BZAutosuggest';
import SessionInfo, { RenderEndTime, RenderSessionLength, RenderStartTime } from './SessionInfo';
import moment from 'moment';

const emptyPersonIcon = '/images/agenda/SpeakerIcon.png';

const getSectionSuggestions = (section) => section.speakers ? section.speakers : section.sessions;

const getSuggestionValue = (suggestion) => suggestion.personId ?
    [suggestion.fullName, suggestion.company || ''].join(', ') :
    suggestion.title;

class SearchAgenda extends Component {
  static propTypes = {
      settings: PropTypes.object.isRequired,
      siteConf: PropTypes.object.isRequired,
      searchAgenda: PropTypes.func.isRequired,
      onSelect: PropTypes.func.isRequired,
      event: PropTypes.object.isRequired,
      isLiveNowBannerOpen: PropTypes.bool
  }

  state = {
      isShowAll: false,
      speakerExists: false,
      fullSuggestions: [],
      suggestions: [],
  }

  renderSpeakerItem = ({ thumbnailUrl, thumbnailSet, fullName, firstname, lastname, company = '' }, { isHighlighted }) => {
      const classHolder = classname({ borderOnImage: !personIcon });
      const className = classname('agenda-flex padding-vertical-small font-size-12', { 'selected': isHighlighted });
      const personIcon = toAssetsExtUrl(thumbnailSet && thumbnailSet['small'] ? thumbnailSet['small'] : thumbnailUrl);

      return <div className={className}>
          <BZPersonIcon
              lastName={firstname}
              firstName={lastname}
              classHolder={classHolder}
              urlImage={personIcon || emptyPersonIcon}
              className="speaker-photo padding-none"
          />
          <div className="padding-left-small">
              <span className="name search-result">
                  <strong>{fullName}</strong>
                  {!!company && <span>, {company}</span>}
              </span>
          </div>
      </div>;
  }

  renderSessionItem = (session, { isHighlighted }) => {
      const { settings, event } = this.props;
      const { title } = session;

      const className = classname('padding-vertical-small font-size-12 sessionItem', { 'selected': isHighlighted });
      return <div className={className}>
          <div className="text-ellipsis font-size-12"><strong>{title}</strong></div>
          <div className="session-info-text search-result">
              <SessionInfo
                  session={session}
                  settings={settings}
                  shouldRenderStartDate
                  event={event}
                  numberOfLines={3}
              />
          </div>
      </div>;
  }

  renderSuggestion = (suggestion, query) => suggestion.personId ?
      this.renderSpeakerItem(suggestion, query) :
      this.renderSessionItem(suggestion, query);

  showAll = () => {
      const { fullSuggestions: suggestions } = this.state;
      this.setState({ isShowAll: true, suggestions });
  }

  renderSectionTitle = (section) => {
      const { siteConf: { color1 } } = this.props;
      const { isShowAll } = this.state;
      const titleStyle = { backgroundImage: `linear-gradient(90deg, var(--page-dropdown-color-3, ${rgbToAlfa(color1, 0.15)}) 0%, rgba(255, 255, 255, 0.15) 100%)` };
      const className = 'bz-uppercase suggestionTitle font-size-12';
      return section.title === 'speakers' ?
          <div style={titleStyle} className={className}>
        speaker's sessions
              {!isShowAll && <div className="showAllLabel" onClick={this.showAll}>See all</div>}
          </div> :
          <div style={titleStyle} className={className}>
              {section.title}
          </div>;
  }


  onSuggestionSelected = (event, selectData) => {
      this.props.onSelect(selectData.suggestion.personId ?
          { speaker: selectData.suggestion } :
          { session: selectData.suggestion }
      );
      this.setState({ suggestions: [], fullSuggestions: [] });
  }

  fetchSuggestions = async(search) => {
      const { searchAgenda } = this.props;
      const { speakers, sessions } = await searchAgenda(search);
      const speakerExists = !!speakers.length;
      const suggestions = [];
      const fullSuggestions = [];
      if (speakers.length) {
          suggestions.push({ title: 'speakers', speakers: speakers.slice(0, 3) });
          fullSuggestions.push({ title: 'speakers', speakers: speakers });
      }
      if (sessions.length) {
          suggestions.push({ title: 'sessions', sessions });
          fullSuggestions.push({ title: 'sessions', sessions });
      }
      this.setState({ isShowAll: speakers.length <= 3, speakerExists, fullSuggestions, suggestions });
      return [];
  }

  render() {
      const { isShowAll, speakerExists, suggestions } = this.state;
      const className = classname({ hiddenMore: !isShowAll, speakerExists, isLiveNowBannerOpen: this.props.isLiveNowBannerOpen });
      return <BZAutosuggest
          multiSection
          autoCleanAfterSelect
          suggestions={suggestions}
          cls={className}
          placeholder="Search Session"
          fetchSuggestions={this.fetchSuggestions}
          getSuggestions={() => []}
          getSuggestionValue={getSuggestionValue}
          getSectionSuggestions={getSectionSuggestions}
          onSuggestionSelected={this.onSuggestionSelected}
          renderSuggestion={this.renderSuggestion}
          renderSectionTitle={this.renderSectionTitle}
      />;

  }
}

export default SearchAgenda;
